import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ServiceRequestModificationData, ServiceRequestModificationOfTypeModify } from '@/types';

/**
 * Stockage des infos relative à la modification d'un déplacement/segment d'un déplacement existant ou l'ajout d'un
 * segment dans un déplacement existant.
 */
const serviceRequestModificationStore = defineStore('serviceRequestModification', () => {
  /** Informations sur le déplacement sélectionné comme devant être modifié dans le formulaire de réservation */
  const serviceRequestModification = ref<ServiceRequestModificationData>();

  /**
   * stocke les données sur le déplacement à modifier
   */
  function setServiceRequestModification(data: ServiceRequestModificationOfTypeModify | undefined) {
    serviceRequestModification.value = data
      ? {
        ...data,
        action: 'modify',
      }
      : undefined;
  }

  /**
   * stocke l'identifiant du déplacement auquel l'utilisateur veut ajouter un nouveau segment
   */
  function setAddLeg(serviceRequestKey: string | undefined) {
    serviceRequestModification.value = serviceRequestKey
      ? {
        action: 'addLeg',
        serviceRequestKey,
      }
      : undefined;
  }

  /**
   * stocke l'identifiant du déplacement à dupliquer
   */
  function setDuplicate(serviceRequestKey: string | undefined) {
    serviceRequestModification.value = serviceRequestKey
      ? {
        action: 'duplicate',
        serviceRequestKey,
      }
      : undefined;
  }

  return {
    serviceRequestModification,
    setServiceRequestModification,
    setAddLeg,
    setDuplicate,
  };
});

export default serviceRequestModificationStore;
